import { FC, memo } from 'react';

import { AppAutocomplete } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteProxyServersQuery } from '@/modules/ProxyServers';

interface Props extends AppAutocompleteComponentProps {}

export const ProxyServersAllAutocomplete: FC<Props> = memo((props) => {
  return (
    <AppAutocomplete<typeof useAutocompleteProxyServersQuery>
      queryArgs={ [] }
      { ...props }
      options={
        (data) =>
          parseSelectData(data, {
            value: 'id',
            label: 'name'
          })
      }
      notFoundDescription="Немає проксі-серверів"
      placeholder="Знайдіть проксі-сервер"
      query={ useAutocompleteProxyServersQuery }
    />
  );
});
